import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";

export const PHONE_LANDSCAPE_MEDIA_QUERY =
    "(orientation: landscape) and (max-height: 600px) and (pointer: coarse)";

export const usePhoneLandscape = (): boolean =>
    useMediaQuery(PHONE_LANDSCAPE_MEDIA_QUERY, {noSsr: true});

export const usePhoneLayout = (): boolean => {
    const theme = useTheme();
    const isNarrow = useMediaQuery(theme.breakpoints.down("sm"), {noSsr: true});
    const isPhoneLandscape = usePhoneLandscape();

    return isNarrow || isPhoneLandscape;
};

export const useCompactDashboardLayout = (): boolean => {
    const theme = useTheme();
    const isNarrow = useMediaQuery(theme.breakpoints.down("md"), {noSsr: true});
    const isPhoneLandscape = usePhoneLandscape();

    return isNarrow || isPhoneLandscape;
};
